import gtag_event from './gtag-init';
import {otp_init, check_otp_session} from '../../global/otp';
import {whatsapp_validation_form} from '../../global/validation-form';
// import {whatsapp_submission} from ''
import {insert_leads_to_db} from '../../global/leads-submission';

jQuery(function ($) {

  let current_form_class = '.virtual-tour-cta-form',
      btn_submit = '#virtual-tour-cta-submit',
      name_field = $('.virtual-tour-cta-form [name="name"]'),
      number_field = $('.virtual-tour-cta-form [name="whatsapp_number"]'),
      alert_field = $('.virtual-tour-cta-form .message-failed'),
      slide_number = 0,
      slide_link = '',
      process_submit = false,
      is_form_filled = false;

  $(document).on('click', '.virtual-tour-slides .btn-next', function (){
    gtag_event('360 click action', 'next_360');
  });

  $(document).on('click', '.virtual-tour-slides .btn-prev', function () {
    gtag_event('360 click action', 'prev_360');
  });

  $('.btn-virtual-tour-lead').click(function(){

    const micrositeProjectStatus = document.querySelector('#nndc-footer__project-status').value;
    if (micrositeProjectStatus.toLowerCase() == 'evergreen') {
      return;
    }

    let the_image,
        the_slide;

    slide_number = $(this).data('slide-id');
    slide_link = $(this).data('url');
    the_slide = $('.slide-' + slide_number);

    the_image = the_slide.find('.slide-image').html();
    gtag_event('Button VR Clicked', 'CTA_360');

    $('#virtual-tour-lead-image').html(the_image).find('img').attr('class', ' ').addClass('w-100 h-85-vh h-25-vh-m cover desktop-border-radius-left-top-bottom');
    if(check_otp_session('on_timer') == false && is_form_filled === false ) {
      $('#virtual-tour-form-modal').modal('show');
    } else {
      showIframe();
    }
  });

  /**
   * Check any required field to change the button state
   */
  function check_vt_form_field() {

    let disable_form = false;

    $('.virtual-tour-cta-form').find('.form-required').each(function(i, el){

      if ( '' === $(el).val() ) {
        disable_form = true;
      }
    });

    if( disable_form ) {
      $('#virtual-tour-cta-submit').attr('disabled', true);
    } else {
      $('#virtual-tour-cta-submit').attr('disabled', false);
    }
  }

  check_vt_form_field();

  $('.form-required').on('change', function(){
    check_vt_form_field();
  });


function submit_whatsapp_form(data) {
  if (data == -1 || data == '') {
    alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
    return;
  }

  if (data.success) {
    // submit success
    $(current_form_class + ' [name=submit_status]').val('1').trigger('change');

    // send GA tracking
    gtag_event('Whatsapp Submission', '360');

    showIframe();
  } else {
    $(current_form_class + ' .message-success').hide();
    $(current_form_class + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
  }
}

// Function to show the iframe in the modal
function showIframe() {
  const iframeSrc = slide_link + '?src=microsite&phone=' + number_field.val() + '&name=' + name_field.val();
  const iframe = $('#virtual-tour-iframe');
  iframe.attr('src', iframeSrc);
  $('#virtual-tour-modal').modal('show');
}

// Function to close the iframe modal
$('#close-iframe').on('click', function(){
  const iframe = $('#virtual-tour-iframe');
  iframe.attr('src', '');
  $('#virtual-tour-modal').modal('hide');
  $('#virtual-tour-form-modal').modal('hide');
});


  $('.virtual-tour-cta-form').on('submit', function(e){

    e.preventDefault();

    let leads_name = name_field.val();
    let leads_number = number_field.val();
    let leads_form = {
      'name': leads_name,
      'number': leads_number,
      'number_field': number_field,
      'alert_field': alert_field,
    };

    if (whatsapp_validation_form(leads_form) == false) {
      gtag_event('Leads form button clicked', '360-not-validated');

      return false;
    }

    if (otp_init(current_form_class, e, leads_number, btn_submit) === false) {
      return false;
    }

    if (true === process_submit) {
      alert('Mohon ditunggu, data anda sedang diproses');
      return;
    }

    gtag_event('Leads form button clicked', '360-validated');

    let data_form = $(this).serialize() + '&current_url=' + $(location).attr('href');

    // insert leads data to DB
    insert_leads_to_db($(this));

    $.ajax({
      type: $(this).attr('method'),
      url: $(this).attr('action'),
      data: data_form,
      beforeSend: function () {
        $(current_form_class + ' .message-text').hide();
        $(current_form_class + ' .message-success').hide();
        $(current_form_class + ' .message-failed').hide();
        $(current_form_class + ' .loader').show();
        $(btn_submit).prop('disabled', true);
        process_submit = true;
        is_form_filled = false;
      },
      success: function (data) {
        $(current_form_class + ' .loader').hide();
        $(current_form_class + ' .message-success').hide();
        submit_whatsapp_form(data);
        $(btn_submit).prop('disabled', false);
        process_submit = false;
        is_form_filled = true;
      },
      error: function (data) {
        console.log('An error occurred.');
        console.log(data);
        $(btn_submit).prop('disabled', false);
        process_submit = true;
        is_form_filled = false;
      },
    });
  });

});


// WEBPACK FOOTER //
// ./scripts/page-template/lgp/virtual-submission.js